module.exports = __webpack_public_path__ + "static/media/golfer-1-a.f1f29567.png";